import HomeView from '@/modules/home/views/HomeView.vue'
import ProductsView from '@/modules/catalog/views/ProductsView.vue'
import ProductDetailsView from '@/modules/catalog/views/ProductDetailsView.vue'
import CartView from '@/modules/cart/views/CartView.vue'
import OrdersList from '@/modules/orders/components/OrdersList.vue'
import OrderDetails from '@/modules/orders/components/OrderDetails.vue'
import NotificationsPage from '@/modules/notifications/views/NotificationsPage.vue'

export const publicRoutes = [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'home', component: HomeView },
  { path: '/products', name: 'products', component: ProductsView, meta: { requiresAuth: true } },
  { path: '/products/:id', name: 'productDetails', component: ProductDetailsView, meta: { requiresAuth: true } },
  { path: '/cart', name: 'cart', component: CartView, meta: { requiresAuth: true } },
  { path: '/orders', name: 'orders', component: OrdersList, meta: { requiresAuth: true } },
  { path: '/orders/:id', name: 'orderDetails', component: OrderDetails, meta: { requiresAuth: true } },
  { path: '/notifications', name: 'notifications', component: NotificationsPage, meta: { requiresAuth: true } }
]